export default "__VITE_ASSET__C$PYMJ_N__"